import React, { useEffect, useState } from "react";
import "../styles/home.css";
import "../styles/table.css";
import "../styles/theme.css";
import Layout from "./Layout";
import DropdownComponent from "./display/DropDownComponent";
import { getOutflowCompSingleDate, getSiteNames } from "../functions/api/details";
import SmallTableComponent from "./display/SmallTable";
import DescriptionList from "./display/DetailsComponent";


const getYesterday = (): string => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return date.toISOString().slice(0, 10); // YYYY-MM-DD
};

// const getToday = (): string => {
//     const date = new Date();
//     date.setDate(date.getDate());
//     return date.toISOString().slice(0, 10); // YYYY-MM-DD
// };

const OutflowCompareComponent: React.FC = () => {
    // Outflow Compare data handling
    const [outflowCompareData, setoutflowCompareData] = useState<any[]>([]);
    const [selectedFromDate, setSelectedFromDate] = useState<string>(getYesterday());
    // const [selectedToDate, setSelectedToDate] = useState<string>(getToday);
    const [code, setSelectedCode] = useState<string>('Lusaka');
    const [siteOptions, setSiteOptions] = useState<any[]>([]);

    // State to store calculated data
    const [calculatedData, setCalculatedData] = useState<any[]>([]);

    // Loading display - TODO: Replace with spinner
    const [loading, setLoading] = useState<boolean>(true);


    // Dropdown for sites
    const populateSiteItems = async() =>{
        // Fetching the site names
        const data =  await getSiteNames();
        if (Array.isArray(data)) {
            setSiteOptions(data);
        } else {
            setSiteOptions([]);
        }

    };
    

    const loadOutflowCompData = async (code: string, date: string) => {
        setLoading(true);
        const data = await getOutflowCompSingleDate(code, date);
        console.log(data)
        if (Array.isArray(data)) {
            setoutflowCompareData(data);
        } else {
            setoutflowCompareData([]);
        }
        setLoading(false);
    };


    useEffect(() => {
        populateSiteItems();
        loadOutflowCompData(code, selectedFromDate);
    }, []);


    const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = e.target.value;
        setSelectedFromDate(newDate);
        loadOutflowCompData(code, newDate);
    };


    // const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const newDate = e.target.value;
    //     // setSelectedToDate(newDate);
    //     loadOutflowCompData(code, selectedFromDate);
    // };

    const handleDropdownChange = (newCode: string) => {
        setSelectedCode(newCode);
        loadOutflowCompData(newCode, selectedFromDate);
    };

        // Difference Calculation
useEffect(() => {
  if (outflowCompareData.length > 0) {
    const dispensed = outflowCompareData.find(
      (row: any) => row.transaction_type === "Total Dispensed"
    );
    const outflow = outflowCompareData.find(
      (row: any) => row.transaction_type === "Total Tank Outflow"
    );

    if (dispensed && outflow) {
      const difference = (outflow.total_volume - dispensed.total_volume).toFixed(2);
      setCalculatedData([
        ...outflowCompareData,
        {
          transaction_type: "Calculated Difference",
          total_volume: difference,
        },
      ]);
    } else {
      const partialData = [...outflowCompareData];

      if (dispensed != null) {
        partialData.push({
          transaction_type: "Only Dispensed Available",
          total_volume: dispensed.total_volume,
        });
      }

      if (outflow != null) {
        partialData.push({
          transaction_type: "Only Outflow Available",
          total_volume: outflow.total_volume,
        });
      }

      setCalculatedData(partialData);
    }
  }
}, [outflowCompareData]);

    return (
      <Layout>
        <div className="home-container" style={{ overflowX: "auto" }}>
          <h2 className="home-header">Outflow Compare</h2>
          <DescriptionList text="This report shows the difference between what is recorded on the main outflow device vs the total dispensed amounts per dispenser."/>
          
          {/* Outflow Compare Data Section */}
          <div className="dropdown">
            <DropdownComponent
              options={siteOptions}
              value={code}
              onChange={handleDropdownChange}
              label="Choose code"
            />
            {code && <p className="small">You selected: {code}</p>}
          </div>
    
          {/* RECEIVE OUTFLOW: Date */}
          <div style={{ marginBottom: "1rem" }}>
            <label style={{ marginRight: "0.5rem" }}>Date:</label>
            <div className="date-picker-wrapper">
              {/* Left Arrow */}
              <button
                className="date-arrow"
                onClick={() => {
                  const prev = new Date(selectedFromDate);
                  prev.setDate(prev.getDate() - 1);
                  handleFromDateChange({
                    target: { value: prev.toISOString().slice(0, 10) },
                  } as React.ChangeEvent<HTMLInputElement>);
                }}
              >
                ←
              </button>
    
              <input
                type="date"
                value={selectedFromDate}
                onChange={handleFromDateChange}
                style={{ padding: "0.4rem" }}
              />
    
              {/* Right Arrow */}
              <button
                className="date-arrow"
                onClick={() => {
                  const next = new Date(selectedFromDate);
                  next.setDate(next.getDate() + 1);
                  handleFromDateChange({
                    target: { value: next.toISOString().slice(0, 10) },
                  } as React.ChangeEvent<HTMLInputElement>);
                }}
              >
                →
              </button>
            </div>
          </div>
    
          {/* Table or Loading */}
          {loading ? (
            <p>Loading...</p>
          ) : outflowCompareData.length > 0 ? (
            <div className="table-scroll-wrapper">
              <div className="table-scroll-inner">
                <SmallTableComponent data={calculatedData} 
                showSearchControls={false} 
                rowClassName={(row) => row.transaction_type === 'Calculated Difference' ? 'summary-row' : ''}
                />
              </div>
            </div>
          ) : (
            <p>No Outflow data available for selected date.</p>
          )}
        </div>
      </Layout>
    );}

export default OutflowCompareComponent;
